export const IS_NEW_FEED_ITEM_ADDED = "IS_NEW_FEED_ITEM_ADDED";

export const setIsNewFeedItemAdded = (bool) => (dispatch) => {
  return dispatch({
    type: IS_NEW_FEED_ITEM_ADDED,
    payload: bool,
  });
};
